import moment from "moment-jalali";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";
import { Button, Popover, Row, Col } from "react-bootstrap";
import { Check2Square, CheckLg, DashCircle, List } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import Loader from "react-loader-spinner";
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import { faClipboardList, faTimes } from "@fortawesome/free-solid-svg-icons";
import { groupSaveCards } from "../store/api/GuaranteeApi";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";

export default function PopGroupSaveCards({ popData, setPopData, holderList, pgType, allowNoProduct }) {
    const dispatch = useDispatch();
    const [currentCard, setCurrentCard] = useState({});
    const [popProduct, setPopProduct] = useState({ show: false });
    const [popStorage, setPopStorage] = useState({ show: false });
    const [pending, setPending] = useState(false);
    function showModalProduct() {
        const onSetData = (data) => {
            if (data?.ProductID) {
                const m = moment(new Date());
                const endDt = m.add("jMonth", Number(data.InstallDeadline ?? 0));
                setCurrentCard({
                    ...currentCard,
                    ProductID: data.ProductID,
                    ProductCode: data.ProductCode,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel,
                    InstallDeadline: endDt.local("en").format("YYYY-MM-DD"),
                    CanEditInstallDeadline: data.CanEditInstallDeadline
                })
            }

        }
        setPopProduct({
            show: true,
            setProductData: onSetData
        })
    }
    function showModalStorage(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.cRowlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            setCurrentCard({ ...currentCard, StorageID: data?.StorageID, StorageName: data?.StorageName });
        }
        setPopStorage({
            show: true,
            isStaffStorage: false,
            setStorageData: onSelectStorage
        })
    }
    function closePop() {
        setPopData(null);
    }
    function submitData() {
        if (!currentCard.ProductSerial || (!allowNoProduct && (!currentCard.ProductID || !currentCard.HolderID))) {
            return;
        }
        if (!currentCard.Count) {
            currentCard.Count = 1;
        }
        setPending(true);
        const onSave = (res) => {
            setPending(!(res.Data || res.Error));
            if (res.Data) {
                setErrorDialog(dispatch, "success", "ثبت کارت");
                setCurrentCard({});
                closePop();
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت کارت");
            }
        }
        groupSaveCards(currentCard, onSave);
    }
    const posStyle = useMemo(() => {
        if (popData) {
            return {
                left: popData.pageX + 15,
                top: popData.pageY - 300
            };
        }
        return { display: "none" };
    }, [popData]);
    if (!popData) {
        return null;
    }
    return (
        <>
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} defaultSalePrice=""
                defaultSalePriceLabel="" defaultStorages="" hideNewProduct={true} />
            <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
            <Popover style={{ fontSize: "12px", fontFamily: "Vazir", minWidth: "420px", ...posStyle, zIndex:"1050" }} className="mt-5">
                <Popover.Title as="h3" className="headerStyle">
                    <span>  <FontAwesomeIcon icon={faClipboardList} size="lg" />&nbsp;ثبت گروهی کارتهای گارانتی</span>
                    <FontAwesomeIcon icon={faTimes} size="lg" onClick={closePop} style={{ float: "left" }} />
                </Popover.Title>
                <Popover.Content className="bodyStyle" style={{ padding: ".5rem .5rem" }}>
                    <Row className="rowBorder" style={{ fontSize: "12px", padding: "4px" }}>
                        <Row>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>تاریخ و مدت:</Col>
                            <Col style={{ padding: 1, alignContent: "center" }} md={6}>
                                <DatePicker timePicker={false} isGregorian={false} placeholder="آغاز گارانتی" className="tableRowInput m-0"

                                    onChange={val => setCurrentCard({ ...currentCard, GuaranteeStartDate: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>
                                <input style={{ color: "blue" }} placeholder="مدت گارانتی" className="tableRowInput" type="number" onChange={e => currentCard.GuaranteeTimeInMonth = e.target.value} /></Col>
                        </Row>
                        <Row>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>تاریخ تولید/خرید: </Col>
                            <Col style={{ padding: 1, alignContent: "center" }}>
                                <DatePicker timePicker={false} isGregorian={false} className="tableRowInput m-0" placeholder="تاریخ تولید"
                                    onChange={val => setCurrentCard({ ...currentCard, ProductCreationDate: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col style={{ padding: 1, alignContent: "center" }}>
                                <DatePicker timePicker={false} isGregorian={false} className="tableRowInput m-0" placeholder="تاریخ خرید"
                                    onChange={val => setCurrentCard({ ...currentCard, PurchaseDate: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>محل/اپراتور تولید: </Col>
                            <Col style={{ padding: 1, alignContent: "center" }}><input className="tableRowInput" placeholder="محل تولید" defaultValue={currentCard.Manufacturer ?? ""} onChange={e => currentCard.Manufacturer = e.target.value} /></Col>
                            <Col style={{ padding: 1, alignContent: "center" }}><input className="tableRowInput" placeholder="اپراتور تولید" defaultValue={currentCard.ProductionOperator ?? ""} onChange={e => currentCard.ProductionOperator = e.target.value} /></Col>
                        </Row>
                        <Row>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>مهلت نصب/فعالسازی: </Col>
                            <Col style={{ padding: 1, alignContent: "center" }}>
                                <DatePicker timePicker={false} isGregorian={false} className="tableRowInput m-0" placeholder="مهلت نصب"
                                    value={(currentCard.InstallDeadline ?? "") !== "" ? moment(currentCard.InstallDeadline) : null}
                                    disabled={!(currentCard.CanEditInstallDeadline ?? true)}
                                    onChange={val => {
                                        let newDate = null;
                                        if (!(val && val.isSame(moment(), "day"))) {
                                            newDate = val?.format("YYYY-MM-DD") ?? "";
                                        }

                                        //  از updater function استفاده می‌کنیم تا از stale state جلوگیری کنیم.
                                        // دلیلش اینه که اگر از currentCard مستقیم استفاده کنیم، ممکنه نسخه قدیمی باشه
                                        // چون onChange ممکنه با closure قدیمی ساخته شده باشه (قبل از آخرین تغییر state).
                                        // بنابراین همیشه از prev => {...} استفاده می‌کنیم تا مطمئن باشیم آخرین state رو داریم.
                                        // دلیل شفاهی این کار هم اینه که وقتی از بیرون مقدار InstallDeadline تغییر میکرد onChange هم فراخوانی میشد که باعث رندر اضافه میشد
                                        setCurrentCard((prev) => {
                                            if (newDate !== prev?.InstallDeadline) {
                                                return { ...prev, InstallDeadline: newDate };
                                            }
                                            return prev;
                                        });
                                    }
                                    }
                                />
                            </Col>
                            <Col style={{ padding: 1, alignContent: "center" }}>
                                <DatePicker timePicker={false} isGregorian={false} className="tableRowInput m-0" placeholder="مهلت فعالسازی"
                                    value={(currentCard.ActiveDeadline ?? "") !== "" ? moment(currentCard.ActiveDeadline) : null}
                                    onChange={val => {
                                        let newDate = null;
                                        if (!(val && val.isSame(moment(), "day"))) {
                                            newDate = val?.format("YYYY-MM-DD") ?? "";
                                        }

                                        //  از updater function استفاده می‌کنیم تا از stale state جلوگیری کنیم.
                                        // دلیلش اینه که اگر از currentCard مستقیم استفاده کنیم، ممکنه نسخه قدیمی باشه
                                        // چون onChange ممکنه با closure قدیمی ساخته شده باشه (قبل از آخرین تغییر state).
                                        // بنابراین همیشه از prev => {...} استفاده می‌کنیم تا مطمئن باشیم آخرین state رو داریم.
                                        // دلیل شفاهی این کار هم اینه که وقتی از بیرون مقدار ActiveDeadline تغییر میکرد onChange هم فراخوانی میشد که باعث رندر اضافه میشد
                                        setCurrentCard((prev) => {
                                            if (newDate !== prev?.ActiveDeadline) {
                                                return { ...prev, ActiveDeadline: newDate };
                                            }
                                            return prev;
                                        });
                                    }
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>انبار ثبت رسید:</Col>
                            <Col style={{ padding: 1, alignContent: "center" }}>
                                <div>
                                    <input className="tableRowInput" onKeyDown={showModalStorage} value={currentCard.StorageName ?? ""} readOnly />
                                    <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={showModalStorage}><List size={17} /></Button>
                                </div>
                            </Col>
                        </Row>

                    </Row>
                    <Row className="rowBorder mt-1" style={{ padding: "4px", fontSize: "12px" }}>
                        <Row>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>نام برند:{!allowNoProduct && <span className="errors">*</span>}</Col>
                            <Col md={9} style={{ padding: 1, alignContent: "center" }}>
                                {
                                    Array.isArray(holderList ?? "") ?
                                        <select className="tableRowInput" onChange={e => currentCard.HolderID = e.target.value} defaultValue={currentCard.HolderID} style={{ width: "100%" }}>
                                            <option value="">انتخاب کنید</option>
                                            {holderList.map((item, i) =>
                                                <option key={i} value={item.ID}>{item.HolderName}</option>)
                                            }
                                        </select> :
                                        <div className="tableRowInput">
                                            <Loader type="BallRowiangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>محصول:{!allowNoProduct && <span className="errors">*</span>} </Col>
                            <Col md={9} style={{ padding: 1, alignContent: "center" }}>
                                <div>
                                    <input className="tableRowInput" value={(currentCard.ProductName ?? "") + "-" + (currentCard.ProductModel ?? "")} />
                                    <Button className="btn-input-tiny" style={{ top: 2, left: 2 }} onClick={showModalProduct}><List size={17} /></Button>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>شماره سریال:<span className="errors">*</span> </Col>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>
                                <input className="tableRowInput" title="پسوند" placeholder="پسوند" onChange={e => currentCard.SerialSuffix = e.target.value} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px", textAlign:"left" }} />
                            </Col>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>
                                <input type="number" className="tableRowInput" title="شمارنده" placeholder="شمارنده" onChange={e => currentCard.ProductSerial = e.target.value} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px", textAlign:"left" }} />
                            </Col>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>
                                <input className="tableRowInput" title="پیشوند" placeholder="پیشوند" onChange={e => currentCard.SerialPrefix = e.target.value} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px", textAlign:"left" }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3} style={{ padding: 1, alignContent: "center" }}>
                                تعداد:<span className="errors">*</span>
                            </Col>
                            <Col md={5} style={{ padding: 1, alignContent: "center" }}>
                                <input type="number" className="tableRowInput" onChange={e => currentCard.Count = e.target.value} min={1} defaultValue={1} />
                            </Col>
                        </Row>
                    </Row>
                    <div className="mt-1">
                        <Button variant="info" className="group-Btn" onClick={submitData}><Check2Square size={18} />&nbsp; ثبت کارتها</Button>
                        <Button variant="danger" className="group-Btn" onClick={closePop}><DashCircle size={18} />&nbsp; انصراف</Button>
                    </div>
                </Popover.Content>
            </Popover>
        </>
    )
}